import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "20"}
    height={props.height || "20"}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_219_2201)">
      <path
        d="M16.5697 22.4598C16.8002 21.038 15.8345 19.6987 14.4128 19.4682C12.991 19.2377 11.6517 20.2034 11.4212 21.6252C11.1907 23.0469 12.1564 24.3862 13.5782 24.6167C14.9999 24.8472 16.3392 23.8815 16.5697 22.4598Z"
        fill="#556987"
      />
      <path
        d="M27.2215 8.8235C23.4629 5.06494 18.6293 3.3466 14 3.3466C9.3707 3.3466 4.53709 5.06494 0.778478 8.8235C-0.260257 9.86344 -0.255499 11.4738 0.768798 12.5024C2.04794 13.7957 3.72269 13.2809 4.47262 12.5059C7.01854 9.96335 10.4018 8.56313 14 8.56313C17.5982 8.56313 20.9815 9.96335 23.5274 12.5059C24.2773 13.2809 25.9521 13.7957 27.2312 12.5024C28.2555 11.4738 28.2603 9.86344 27.2215 8.8235Z"
        fill="#556987"
      />
      <path
        d="M14.0002 11.3916C11.4068 11.3916 8.62416 12.3557 6.46788 14.5115C5.41586 15.5635 5.43681 17.1812 6.47838 18.2118C7.51258 19.239 9.12165 19.2346 10.1556 18.2007C11.1825 17.1738 12.5478 16.6083 14.0001 16.6083C15.4524 16.6083 16.8177 17.1738 17.8446 18.2007C18.8786 19.2346 20.4877 19.239 21.5218 18.2118C22.5634 17.1812 22.5843 15.5635 21.5323 14.5115C19.3762 12.3558 16.5935 11.3916 14.0002 11.3916Z"
        fill="#556987"
      />
    </g>
    <defs>
      <clipPath id="clip0_219_2201">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
